var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91406 0C6.25132 0 5.71406 0.537259 5.71406 1.2V2.4H4.51406C2.52584 2.4 0.914062 4.01178 0.914062 6V20.4C0.914062 22.3882 2.52584 24 4.51406 24H21.3141C23.3023 24 24.9141 22.3882 24.9141 20.4V6C24.9141 4.01178 23.3023 2.4 21.3141 2.4H20.1141V1.2C20.1141 0.537258 19.5768 0 18.9141 0C18.2513 0 17.7141 0.537259 17.7141 1.2V2.4H8.11406V1.2C8.11406 0.537258 7.5768 0 6.91406 0ZM9.31406 13.2C9.31406 12.5373 9.85132 12 10.5141 12H18.9141C19.5768 12 20.1141 12.5373 20.1141 13.2C20.1141 13.8627 19.5768 14.4 18.9141 14.4H10.5141C9.85132 14.4 9.31406 13.8627 9.31406 13.2ZM5.71406 18C5.71406 17.3373 6.25132 16.8 6.91406 16.8H14.1141C14.7768 16.8 15.3141 17.3373 15.3141 18C15.3141 18.6627 14.7768 19.2 14.1141 19.2H6.91406C6.25132 19.2 5.71406 18.6627 5.71406 18Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.095663dcdf8e405466f9ec6e750f28d8.svg";
export { ForwardRef as ReactComponent };